import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerSection: {
      width: '80%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    matchTitle: {
      fontFamily: 'Poppins !important',
      fontSize: 20,
      fontWeight: 500,
      '& span': {
        fontFamily: 'Poppins !important',
        fontWeight: 700,
      },
    },
    containerMatch: {
      padding: 40,
      borderRadius: 5,
      border: '1px solid #FFF',
      background: 'linear-gradient(180deg, #FFF 0%, #F7F6F6 100%)',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
    },
    btnPrimarySeek: {
      background: '#000A8C',
      textTransform: 'none',
    },
    titleTable: {
      color: '#000A8C',
      fontFamily: 'Poppins',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 700,
    },
    cellule: {
      padding: '10px',
      color: '#151528',
      fontFamily: 'Poppins',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 300,
    },
    celluleMatch: {
      fontFamily: 'Poppins',
      padding: '10px',
      color: '#151528',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
    },
  })
);
